.footer {
	width: 100%;
	height: 52px !important;
	border-top: solid 1px var(--border-primary);
	background-color: var(--elevation-low);
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px;
	height: fit-content;
}

.refetchAndNavigation {
	display: flex;
	gap: 8px;
}

.refetch {
	width: 28px;
	height: 28px;
	color: var(--content-primary);
	border: solid 1px var(--border-primary);
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: var(--elevation-default);
}

.refetch:hover {
	background-color: var(--elevation-medium);
}

.perPage {
	display: flex;
	border-radius: 8px;
	border: var(--border-primary) 1px solid;
	overflow: hidden;
}

.perPage button:hover {
	background-color: var(--elevation-medium);
}

.perPage button {
	background-color: var(--elevation-default);
	width: 28px;
	height: 28px;
	/*
     * Required to override generic styling from old Layout
     */
	min-width: 28px;
	min-height: 28px;
	color: var(--content-primary);
	padding: 0;
	font-size: unset;
	line-height: unset;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 2px;
}

.perPage .selectedPerPage {
	background-color: var(--elevation-medium);
}

.perPage button:not(last-child) {
	border-right: var(--border-primary) 1px solid;
}
